import { destroy } from '@alltrails/core/utils/destroy';

export async function destroyFlashMessage(id: string): Promise<void> {
  await destroy(`/api/alltrails/v1/web/flash_messages/${id}`);
}
